export enum ProductIconType {
  ALERT_POLICY = "alert-policy",
  ALERT_TRIGGERED = "alert-triggered",
  ACCESS_KEY = "access-key",
  CERTIFICATE = "certificate",
  CONTAINER = "container",
  CONTROL_PANEL = "control-panel",
  COST = "cost-tag",
  CREDITS = "credits",
  DBAAS_KAFKA = "dbaas-kafka",
  DBAAS_KAFKA_SELECTED = "dbaas-kafka-selected",
  DBAAS_KAFKA_UNSELECTED = "dbaas-kafka-unselected",
  DBAAS_MYSQL = "dbaas-mysql",
  DBAAS_MYSQL_SELECTED = "dbaas-mysql-selected",
  DBAAS_MYSQL_UNSELECTED = "dbaas-mysql-unselected",
  DBAAS_MONGO = "dbaas-mongo",
  DBAAS_MONGO_SELECTED = "dbaas-mongo-selected",
  DBAAS_MONGO_UNSELECTED = "dbaas-mongo-unselected",
  DBAAS_OPENSEARCH = "dbaas-opensearch",
  DBAAS_OPENSEARCH_SELECTED = "dbaas-opensearch-selected",
  DBAAS_OPENSEARCH_UNSELECTED = "dbaas-opensearch-unselected",
  DBAAS_POSTGRES = "dbaas-postgres",
  DBAAS_POSTGRES_SELECTED = "dbaas-postgres-selected",
  DBAAS_POSTGRES_UNSELECTED = "dbaas-postgres-unselected",
  DBAAS_REDIS = "dbaas-redis",
  DBAAS_REDIS_SELECTED = "dbaas-redis-selected",
  DBAAS_REDIS_UNSELECTED = "dbaas-redis-unselected",
  DBAAS_VALKEY = "dbaas-valkey",
  DBAAS_VALKEY_SELECTED = "dbaas-valkey-selected",
  DBAAS_VALKEY_UNSELECTED = "dbaas-valkey-unselected",
  DBAAS_PRIMARY_2_STANDBY = "dbaas-primary-2-standby",
  DBAAS_PRIMARY_STANDBY = "dbaas-primary-standby",
  DBAAS_PRIMARY = "dbaas-primary",
  DBAAS_READ_ONLY = "dbaas-read-only",
  DOCKER = "docker",
  DOMAIN = "domain",
  DROPLET_SNAPSHOT = "droplet-snapshot",
  DROPLET = "droplet",
  DROPLET_AUTOSCALE_POOLS = "droplet-autoscale-pools",
  EMAIL = "email",
  GPU = "gpu",
  GPU_SNAPSHOT = "gpu-snapshot",
  MULTI_NODE_NETWORK = "multi-node-network",
  DROPLET_ALMALINUX_BLUE = "droplet-almalinux-blue",
  DROPLET_ALMALINUX_GRAY = "droplet-almalinux-gray",
  DROPLET_CENTOS_BLUE = "droplet-centos-blue",
  DROPLET_CENTOS_GRAY = "droplet-centos-gray",
  DROPLET_DEBIAN_BLUE = "droplet-debian-blue",
  DROPLET_DEBIAN_GRAY = "droplet-debian-gray",
  DROPLET_FEDORA_BLUE = "droplet-fedora-blue",
  DROPLET_FEDORA_GRAY = "droplet-fedora-gray",
  DROPLET_ROCKYLINUX_BLUE = "droplet-rockylinux-blue",
  DROPLET_ROCKYLINUX_GRAY = "droplet-rockylinux-gray",
  DROPLET_UBUNTU_BLUE = "droplet-ubuntu-blue",
  DROPLET_UBUNTU_GRAY = "droplet-ubuntu-gray",
  FIREWALL = "firewall",
  FLOATING_IP = "floating-ip",
  K8S_CLUSTER = "k8s-cluster",
  K8S_HIGH_AVAILABILITY = "k8s-high-availability",
  K8S_NODE = "k8s-node",
  K8S_NODE_POOL = "k8s-node-pool",
  LOAD_BALANCER = "load-balancer",
  MARKETPLACE = "marketplace",
  MARKETPLACE_WHITE = "marketplace-white",
  SCALING = "scaling",
  SPACE_FILE = "space-file",
  SPACE_FOLDER = "space-folder",
  /**
   * @deprecated use SPACE_FOLDER instead
   */
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  SPACE_FODLER = "space-folder",
  SPACE = "space",
  STATIC_SITE = "static-site",
  TAG = "tag",
  VENDOR_FORUM = "vendor-forum",
  VENDOR_PORTAL = "vendor-portal",
  VENDOR_PORTAL_WHITE = "vendor-portal-white",
  VOLUME_SNAPSHOT = "volume-snapshot",
  VOLUME = "volume",
  VPC = "vpc",
  VPC_PEERING = "vpc-peering",
  GUIDED_CONFIG = "guided-config",
  MONITORS = "monitors",
  METRICS = "metrics",
  AUTOSCALING_NODE_POOL = "autoscaling-node-pool",
  ADD_ONS = "add-ons",
  FUNCTION = "function",
  APP = "app",
  APP_JOB = "app-job",
  APP_SERVICE = "app-service",
  APP_STATIC_SITE = "app-static-site",
  APP_WORKER = "app-worker",
  APP_FUNCTIONS = "app-functions",
  UPTIME = "uptime",
  NAT_GATEWAY = "vpc-nat-gateway",
}

export const PRODUCT_ICONS = Object.values(ProductIconType);
